export default __webpack_public_path__ + "static/media/dt-logo.3807cc3a.svg";